var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 7.417a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3a.75.75 0 0 1 .75-.75M8 4.934a.9.9 0 0 1 .9.9v.008a.9.9 0 0 1-1.8 0v-.007a.9.9 0 0 1 .9-.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.083a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8 1.083m0 1.5a5.917 5.917 0 1 0 0 11.832A5.917 5.917 0 0 0 8 2.583",
    clipRule: "evenodd"
  })));
};
export default Svg16;